import { CircularProgress } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import Button from "../Button/Button"; // Your shared styled Button component

interface DeleteButtonProps {
  onClick: () => void;
  loading?: boolean;
  disabled?: boolean;
  children?: React.ReactNode;
  icon?: React.ReactNode;
  fullWidth?: boolean;
  styleOverrides?: React.CSSProperties;
  fontSize?: number;
}

const DeleteButton = ({
  onClick,
  loading = false,
  disabled = false,
  children = "Delete",
  icon = <DeleteIcon sx={{ marginRight: 1 }} />,
  fullWidth = false,
  styleOverrides = {},
  fontSize = 16,
}: DeleteButtonProps) => {
  return (
    <Button
      onClick={onClick}
      loading={loading}
      disabled={disabled}
      fullWidth={fullWidth}
      fontSize={fontSize}
      icon={icon}
      styleOverrides={{
        background: "#d32f2f", // red
        boxShadow: "0px 10px 20px #d32f2f33",
        "&:hover": {
          background: "#b71c1c",
        },
        "&:focus": {
          background: "#b71c1c",
        },
        ...styleOverrides,
      }}
    >
      {children}
    </Button>
  );
};

export default DeleteButton;
